var map = {
	"./config": 1113,
	"./config.js": 1113,
	"./config.local": 5410,
	"./config.local.js": 5410,
	"./config.options": 4856,
	"./config.options.js": 4856,
	"./config.prod": 207,
	"./config.prod.js": 207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6109;